/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React from 'react'

import AssetTableCell from './AssetTableCell'
import { convertTemperature, formatDate12, joinStrings, timeSinceFormatted } from './utils'

import { AssetTempMp, TemperatureUnit } from '../types'

type TempMpSummaryColProps = {
  tempMps: AssetTempMp[]
  temperatureUnit?: TemperatureUnit
}

const TempMpSummaryCol: React.FC<TempMpSummaryColProps> = ({ tempMps, temperatureUnit = 'Metric' }) => {
  const tooltip = joinStrings(
    ...tempMps.map((t) => {
      const converted =
        t.temperatureCelsius || t.temperatureCelsius === 0
          ? convertTemperature(t.temperatureCelsius, temperatureUnit)
          : 'No reading'
      let details = `${t.name}: ${converted}`
      if (t.tagOnline) {
        details += ` at ${formatDate12(t.tagOnlineSampleTime)}`
      } else {
        let offlineString = 'Offline'
        let offlineTimeAgo = ''
        if (t.tagOnlineSampleTime) {
          offlineString += ` since ${formatDate12(t.tagOnlineSampleTime)}`
          offlineTimeAgo = ` ${timeSinceFormatted(t.tagOnlineSampleTime)}`
        }
        details += ` (${offlineString})${offlineTimeAgo}`
      }
      return details
    })
  )

  const content = tempMps.length === 0 ? <div className="h-4 w-full flex"></div> : <>Temp MPs: {tempMps.length}</>
  return (
    <AssetTableCell tooltip={tooltip}>
      <div className="w-full h-full">{content}</div>
    </AssetTableCell>
  )
}

export default TempMpSummaryCol
